import {
  AfterContentInit,
  Directive,
  EventEmitter,
  Host,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  Optional,
  Output,
} from "@angular/core";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";

import { BitIconButtonComponent } from "../icon-button/icon-button.component";

import { BitFormFieldComponent } from "./form-field.component";

@Directive({
  selector: "[bitPasswordInputToggle]",
})
export class BitPasswordInputToggleDirective implements AfterContentInit, OnChanges {
  /**
   * Whether the input is toggled to show the password.
   */
  @HostBinding("attr.aria-pressed") @Input() toggled = false;
  @Output() toggledChange = new EventEmitter<boolean>();

  @HostBinding("attr.title") title = this.i18nService.t("toggleVisibility");
  @HostBinding("attr.aria-label") label = this.i18nService.t("toggleVisibility");

  /**
   * Click handler to toggle the state of the input type.
   */
  @HostListener("click") onClick() {
    this.toggled = !this.toggled;
    this.toggledChange.emit(this.toggled);

    this.update();

    this.formField.input?.focus();
  }

  // Optional: GLOSS's own toggles (lock, login, register) are plain buttons with their own eye
  // svg. An empty `bitIconButton` toggle (export, file-password prompt) has only this icon.
  constructor(
    private formField: BitFormFieldComponent,
    private i18nService: I18nService,
    @Optional() @Host() private button: BitIconButtonComponent | null,
  ) {}

  get icon() {
    return this.toggled ? "bwi-eye-slash" : "bwi-eye";
  }

  ngOnChanges(): void {
    this.update();
  }

  ngAfterContentInit(): void {
    this.toggled = this.formField.input.type !== "password";
    this.updateIcon();
  }

  private updateIcon() {
    if (this.button) {
      this.button.icon = this.icon;
    }
  }

  private update() {
    this.updateIcon();
    if (this.formField.input?.type != null) {
      this.formField.input.type = this.toggled ? "text" : "password";
      this.formField.input.spellcheck = this.toggled ? false : undefined;
    }
  }
}
